// export default () => ({
// })

export default () => ({
    users: [],
    usersSelectable: [],
    usersPaginatedData: null,
    user: null,
    isFinding: false,
    foundData: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})